// const serverSrc = 'http://192.168.2.15:8081'
// const serverSrc = 'http://192.168.2.33:8081/api'
const serverSrc = 'https://lubinadmin.guanmeikj.com/api'

export {    
    serverSrc
}   
